<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        View Of Allocated Manpower
    </div>
    <div class="card-body">
        <div>
            <div class="row m-1">
                <div class="col-md-4 px-1">
                    <label class="Label">Branch </label>
                    <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                        [(ngModel)]="BranchId" (change)=" onSelectChange('Branch'); ComboLoad('Client')">
                        <ng-option *ngFor="let segment of BranchMaster" [value]="segment.BranchMasterID">
                            {{ segment.BranchName }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col"></div>
                <div class="col-auto"><br>
                    <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
                        [disabled]="isDisabled" (click)="AdditionandReduction('Addition')">
                        <i class="bi bi-person-add" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Addition':'Loading...'}}
                    </button>
                    &nbsp;<button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
                        [disabled]="isDisabled" (click)="AdditionandReduction('Reduction')">
                        <i class="bi bi-person-dash" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Reduction':'Loading...'}}
                    </button>
                </div>

            </div>
            <div class="row m-1">
                <div class="col-md-8 px-1">
                    <label class="Label">Client</label>
                    <ng-select name="client" [items]="ClientLoad" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" [(ngModel)]="ClientId"
                        (change)="onSelectChange('Client'); ComboLoad('Site')">
                        <ng-option *ngFor="let segment of ClientLoad" [value]="segment.ClientGroupMasterID">
                            {{ segment.ClientGroupName }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-3 px-1"><br>
                    <input mdbCheckbox class="form-check-input" style="height: 15px; width: 15px; font-weight: bold;"
                        name="header" type="checkbox"  (change)="toggleSelect()" [(ngModel)]="selectcheck"
                        value="" />&nbsp;&nbsp;<label style="font-weight: bold; font-size: 14px;">Include All
                        Transactions</label>
                </div>
            </div>
            <div class="row m-1">
                <div class="col-md-8 px-1">
                    <label class="Label">Site</label>
                    <ng-select name="site" [items]="SiteLoad" bindLabel="SiteName" bindValue="SiteMasterID"
                        [(ngModel)]="SiteId" (change)="onSelectChange('Site');">
                        <ng-option *ngFor="let segment of SiteLoad" [value]="segment.SiteMasterID">
                            {{ segment.SiteName }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-2 px-1">
                    <label class="Label">Date</label>
                    <div class="input-group" style="height: auto;">
                        <input class="form-control" name="WorkOrderDate" placeholder="Ex. DD/MMM/YYYY"
                            [(ngModel)]="dtobj" #HolidayDate="ngModel" ngbDatepicker #d1="ngbDatepicker"
                            [minDate]="{ year:1930, month: 12, day: 31 }" [maxDate]="{ year: 2124, month: 12, day: 31 }"
                            style="height: auto; font-size: small; padding: 0.2rem 0.4rem;"
                            [ngModelOptions]="{standalone: true}" readonly [disabled]="selectcheck" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d1.toggle()" type="button"
                            style="height: auto; padding: 0.25rem 0.4rem; font-size: small;" [disabled]="selectcheck"></button>
                    </div>
                </div>
                <div class="col-md-2 px-1"><br>
                    <button class="btn btn-sm btn-primary" name="submit" (click)="add()">
                        <i class="bi bi-download" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Load':'Loading...'}}
                    </button>
                    &nbsp;<button class="btn btn-sm btn-primary" name="refresh" (click)="refresh()">
                        <i class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Back':'Loading...'}}
                    </button>
                    
                </div>
                <!-- <div class="col-md-2 px-1"><br>
                    <label class="Label1">Total:</label>
                    <label class="Label1">{{Total}}</label>
                </div> -->
            </div>
            <div class="card border-radius-0 mt-1 p-0">
                <div class="card-header">
                    Data
                </div>
                <div class="card-body p-1" style="overflow: auto;">
                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Entry No</th>
                                <th scope="col" style="display: none;">ESS_ShiftWiseManpowerMasterId</th>
                                <th scope="col">WONo</th>
                                <th scope="col">WODate</th>
                                <th scope="col" style="display: none;">Branch Id</th>
                                <th scope="col" style="display: none;">Branch Name</th>
                                <th scope="col" style="display: none;">Client Id</th>
                                <th scope="col">ClientGroup Name</th>
                                <th scope="col" style="display: none;">Site Id</th>
                                <th scope="col">Site Name</th>
                                <th scope="col" style="display: none;">Allocation Type</th>
                                <th scope="col">No Of Person</th>
                                <th scope="col" style="display: none;">IsAutoReduction</th>
                                <th scope="col" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let site of ViewDataObj; let i = index">
                                <th scope="row" [ngClass]="{'highlight-row': site.AllocationType === 'O'}">{{ i + 1 }}
                                </th>
                                <td [ngClass]="{'highlight-row': site.AllocationType === 'O'}">{{ site['EntryNo'] }}
                                </td>
                                <td style="display: none;">{{ site['ESS_ShiftWiseManpowerMasterId'] }}</td>
                                <td [ngClass]="{'highlight-row': site.AllocationType === 'O'}">{{ site['WONo'] }}</td>
                                <td [ngClass]="{'highlight-row': site.AllocationType === 'O'}">{{ site['WODate'] }}</td>
                                <td style="display: none;">{{ site['BranchId'] }}</td>
                                <td style="display: none;">{{ site['BranchName'] }}</td>
                                <td style="display: none;">{{ site['ClientId'] }}</td>
                                <td [ngClass]="{'highlight-row': site.AllocationType === 'O'}">{{
                                    site['ClientGroupName'] }}</td>
                                <td style="display: none;">{{ site['SiteId'] }}</td>
                                <td [ngClass]="{'highlight-row': site.AllocationType === 'O'}">{{ site['SiteName'] }}
                                    &nbsp;
                                    <span *ngIf="site.AllocationType === 'O'"
                                        style="color: rgb(221, 119, 24);">(OP)</span> <span *ngIf="site.IsAutoReduction"
                                        style="color:rgb(4, 178, 231)">(AUTO)</span>
                                </td>
                                <td style="display: none;">{{ site['AllocationType'] }}</td>
                                <td class="right-align" [ngClass]="{'highlight-row': site.AllocationType === 'O'}">
                                    <span *ngIf="site.AllocationType === 'R'">-</span>
                                    <span *ngIf="site.AllocationType === 'A' || site.AllocationType === 'O'">+</span>
                                    <span class="no-of-person">{{ site.NoOfPerson }}</span>
                                </td>
                                <td style="display: none;">{{site.IsAutoReduction}}</td>
                                <!-- <td [ngClass]="{'colHide': !this.common.PageRight.IsEdit},'highlight-row': site.AllocationType === 'O'"> -->
                                <td [ngClass]="{
                                        'colHide': !this.common.PageRight.IsEdit,
                                        'highlight-row': site.AllocationType === 'O'
                                     }">
                                    <button class="btn btn-sm btn-group-toggle" (click)="onEditClick(site)">
                                        <i class="bi bi-pencil-square text-warning"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>